<template>
  <div class="width-box w600">
    <el-form class="pop-form-wrap" label-width="100px" :model="formData" ref="projectInfoForm" v-if="formData">
      <el-form-item label="Name" prop="PtName">
        <el-input size="small" v-model="formData.PtName"></el-input>
      </el-form-item>
      <el-form-item label="Describe" prop="PtDescribe">
        <el-input size="small" v-model="formData.PtDescribe" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="Sort" prop="PtSort">
        <el-input size="small" v-model.number="formData.PtSort"></el-input>
      </el-form-item>
      <el-form-item label="Is Leaf" prop="IsLeaf">
        <el-switch v-model="formData.IsLeaf" on-text="" off-text=""></el-switch>
      </el-form-item>
      <el-form-item>
        <div class="pop-center-btn-wrap">
          <el-button type="primary" @click="doAdd('projectInfoForm')" v-if='!formData.Id'>add</el-button>
          <el-button type="primary" @click="doUpdate('projectInfoForm')" v-if='formData.Id'>save</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tools from '@/components/common/tools'

// 数据对象
let dataStore = tools.createDataStore({
  PtFacode: '0',
  PtName: '',
  PtDescribe: '',
  PtSort: '',
  IsLeaf: false
})

// 请求相关操作
let page = {
  methods: {
    // add操作
    addDataAjax() {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.IsLeaf ? 1 : 0
      tools.commonAjax.call(this, true, '/Ajax/AddProductTypeInAdmin', data).then(() => {
        this.$message.success('Operate success!')
        // add成功
        this.$emit('addSuccess')
      })
    },
    // 修改操作
    updateDataAjax(id, state) {
      let data = tools.getModel(this.formData)
      data.IsLeaf = data.IsLeaf ? 1 : 0
      tools.commonAjax.call(this, true, '/Ajax/UpdateProductTypeInAdmin', data).then(() => {
        this.$message.success('Operate success!')
        // 修改成功
        this.$emit('updateSuccess')
      })
    }
  }
}

export default {
  name: 'ProductTypeForm',
  componentName: 'ProductTypeForm',
  mixins: [page],
  data() {
    return {
      formData: dataStore.getDefaultData()
    }
  },
  methods: {
    // 重置表单值
    resetValue() {
      this.formData = dataStore.getDefaultData()
    },
    // 设置表单值
    setValue(value) {
      value.IsLeaf = !!value.IsLeaf
      this.formData = tools.extendData(dataStore.getDefaultData(), value || {})
    },
    // 发布
    doAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    doUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateDataAjax()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// ProductTypeForm.vue?257ca151